/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * CyrenCare API
 * CyrenCare NestJS REST API for healthcare survey platform
 * OpenAPI spec version: 2.0
 */
import {
  useInfiniteQuery,
  useMutation,
  useQuery
} from '@tanstack/react-query'
import type {
  InfiniteData,
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query'
import type {
  BatchFindByTreeIdsDto,
  BatchTreeQuestionsResponseDto,
  BodySelectTreeConfigResponseDto,
  CopyQuestionsDto,
  CopyQuestionsResponseDto,
  CreateQuestionDto,
  CreateQuestionResponseDto,
  QuestionControllerFindByKeyParams,
  QuestionControllerFindBySurveyParams,
  QuestionControllerFindByTreeIdParams,
  QuestionControllerGetBodySelectTreeConfigParams,
  QuestionControllerSearchParams,
  QuestionDetailResponseDto,
  QuestionResponseDto,
  QuestionWithAnswerLabelsResponseDto,
  UpdateQuestionDto,
  UpdateQuestionResponseDto
} from '.././types'
import { customInstance } from '../../custom-instance';
import type { ErrorType } from '../../custom-instance';


type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];


/**
 * Searches translations (qsTitle, treeSx) by keyword in key/value and returns matching questions. Empty keyword returns the first 100 matches (V1 behavior).
 * @summary Search questions by keyword within a survey
 */
export const questionControllerSearch = (
    params: QuestionControllerSearchParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<QuestionResponseDto[]>(
      {url: `/questions/search`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getQuestionControllerSearchQueryKey = (params: QuestionControllerSearchParams,) => {
    return [`/questions/search`, ...(params ? [params]: [])] as const;
    }

    
export const getQuestionControllerSearchInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof questionControllerSearch>>>, TError = ErrorType<unknown>>(params: QuestionControllerSearchParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof questionControllerSearch>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getQuestionControllerSearchQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof questionControllerSearch>>> = ({ signal }) => questionControllerSearch(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof questionControllerSearch>>, TError, TData> & { queryKey: QueryKey }
}

export type QuestionControllerSearchInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof questionControllerSearch>>>
export type QuestionControllerSearchInfiniteQueryError = ErrorType<unknown>

/**
 * @summary Search questions by keyword within a survey
 */
export const useQuestionControllerSearchInfinite = <TData = InfiniteData<Awaited<ReturnType<typeof questionControllerSearch>>>, TError = ErrorType<unknown>>(
 params: QuestionControllerSearchParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof questionControllerSearch>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getQuestionControllerSearchInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getQuestionControllerSearchQueryOptions = <TData = Awaited<ReturnType<typeof questionControllerSearch>>, TError = ErrorType<unknown>>(params: QuestionControllerSearchParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof questionControllerSearch>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getQuestionControllerSearchQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof questionControllerSearch>>> = ({ signal }) => questionControllerSearch(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof questionControllerSearch>>, TError, TData> & { queryKey: QueryKey }
}

export type QuestionControllerSearchQueryResult = NonNullable<Awaited<ReturnType<typeof questionControllerSearch>>>
export type QuestionControllerSearchQueryError = ErrorType<unknown>

/**
 * @summary Search questions by keyword within a survey
 */
export const useQuestionControllerSearch = <TData = Awaited<ReturnType<typeof questionControllerSearch>>, TError = ErrorType<unknown>>(
 params: QuestionControllerSearchParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof questionControllerSearch>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getQuestionControllerSearchQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Returns a single question with its answerKeys and their translated labels.
 * @summary Get a question by key with translated answer labels
 */
export const questionControllerFindByKey = (
    params: QuestionControllerFindByKeyParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<QuestionWithAnswerLabelsResponseDto>(
      {url: `/questions/by-key`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getQuestionControllerFindByKeyQueryKey = (params: QuestionControllerFindByKeyParams,) => {
    return [`/questions/by-key`, ...(params ? [params]: [])] as const;
    }

    
export const getQuestionControllerFindByKeyInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof questionControllerFindByKey>>>, TError = ErrorType<void>>(params: QuestionControllerFindByKeyParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof questionControllerFindByKey>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getQuestionControllerFindByKeyQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof questionControllerFindByKey>>> = ({ signal }) => questionControllerFindByKey(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof questionControllerFindByKey>>, TError, TData> & { queryKey: QueryKey }
}

export type QuestionControllerFindByKeyInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof questionControllerFindByKey>>>
export type QuestionControllerFindByKeyInfiniteQueryError = ErrorType<void>

/**
 * @summary Get a question by key with translated answer labels
 */
export const useQuestionControllerFindByKeyInfinite = <TData = InfiniteData<Awaited<ReturnType<typeof questionControllerFindByKey>>>, TError = ErrorType<void>>(
 params: QuestionControllerFindByKeyParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof questionControllerFindByKey>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getQuestionControllerFindByKeyInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getQuestionControllerFindByKeyQueryOptions = <TData = Awaited<ReturnType<typeof questionControllerFindByKey>>, TError = ErrorType<void>>(params: QuestionControllerFindByKeyParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof questionControllerFindByKey>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getQuestionControllerFindByKeyQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof questionControllerFindByKey>>> = ({ signal }) => questionControllerFindByKey(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof questionControllerFindByKey>>, TError, TData> & { queryKey: QueryKey }
}

export type QuestionControllerFindByKeyQueryResult = NonNullable<Awaited<ReturnType<typeof questionControllerFindByKey>>>
export type QuestionControllerFindByKeyQueryError = ErrorType<void>

/**
 * @summary Get a question by key with translated answer labels
 */
export const useQuestionControllerFindByKey = <TData = Awaited<ReturnType<typeof questionControllerFindByKey>>, TError = ErrorType<void>>(
 params: QuestionControllerFindByKeyParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof questionControllerFindByKey>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getQuestionControllerFindByKeyQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Returns entry question and subpart questions for body_select tree, with translated answer labels.
 * @summary Get body select tree config for live testing
 */
export const questionControllerGetBodySelectTreeConfig = (
    params: QuestionControllerGetBodySelectTreeConfigParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<BodySelectTreeConfigResponseDto>(
      {url: `/questions/body-select-tree-config`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getQuestionControllerGetBodySelectTreeConfigQueryKey = (params: QuestionControllerGetBodySelectTreeConfigParams,) => {
    return [`/questions/body-select-tree-config`, ...(params ? [params]: [])] as const;
    }

    
export const getQuestionControllerGetBodySelectTreeConfigInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof questionControllerGetBodySelectTreeConfig>>>, TError = ErrorType<unknown>>(params: QuestionControllerGetBodySelectTreeConfigParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof questionControllerGetBodySelectTreeConfig>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getQuestionControllerGetBodySelectTreeConfigQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof questionControllerGetBodySelectTreeConfig>>> = ({ signal }) => questionControllerGetBodySelectTreeConfig(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof questionControllerGetBodySelectTreeConfig>>, TError, TData> & { queryKey: QueryKey }
}

export type QuestionControllerGetBodySelectTreeConfigInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof questionControllerGetBodySelectTreeConfig>>>
export type QuestionControllerGetBodySelectTreeConfigInfiniteQueryError = ErrorType<unknown>

/**
 * @summary Get body select tree config for live testing
 */
export const useQuestionControllerGetBodySelectTreeConfigInfinite = <TData = InfiniteData<Awaited<ReturnType<typeof questionControllerGetBodySelectTreeConfig>>>, TError = ErrorType<unknown>>(
 params: QuestionControllerGetBodySelectTreeConfigParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof questionControllerGetBodySelectTreeConfig>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getQuestionControllerGetBodySelectTreeConfigInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getQuestionControllerGetBodySelectTreeConfigQueryOptions = <TData = Awaited<ReturnType<typeof questionControllerGetBodySelectTreeConfig>>, TError = ErrorType<unknown>>(params: QuestionControllerGetBodySelectTreeConfigParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof questionControllerGetBodySelectTreeConfig>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getQuestionControllerGetBodySelectTreeConfigQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof questionControllerGetBodySelectTreeConfig>>> = ({ signal }) => questionControllerGetBodySelectTreeConfig(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof questionControllerGetBodySelectTreeConfig>>, TError, TData> & { queryKey: QueryKey }
}

export type QuestionControllerGetBodySelectTreeConfigQueryResult = NonNullable<Awaited<ReturnType<typeof questionControllerGetBodySelectTreeConfig>>>
export type QuestionControllerGetBodySelectTreeConfigQueryError = ErrorType<unknown>

/**
 * @summary Get body select tree config for live testing
 */
export const useQuestionControllerGetBodySelectTreeConfig = <TData = Awaited<ReturnType<typeof questionControllerGetBodySelectTreeConfig>>, TError = ErrorType<unknown>>(
 params: QuestionControllerGetBodySelectTreeConfigParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof questionControllerGetBodySelectTreeConfig>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getQuestionControllerGetBodySelectTreeConfigQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Accepts an array of tree IDs and returns questions for each tree, keyed by tree ID. This avoids N+1 API calls when loading many trees at once.
 * @summary Get questions for multiple tree IDs in a single request
 */
export const questionControllerFindByTreeIdsBatch = (
    batchFindByTreeIdsDto: BatchFindByTreeIdsDto,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<BatchTreeQuestionsResponseDto>(
      {url: `/questions/tree/batch`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: batchFindByTreeIdsDto
    },
      options);
    }
  


export const getQuestionControllerFindByTreeIdsBatchMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof questionControllerFindByTreeIdsBatch>>, TError,{data: BatchFindByTreeIdsDto}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof questionControllerFindByTreeIdsBatch>>, TError,{data: BatchFindByTreeIdsDto}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof questionControllerFindByTreeIdsBatch>>, {data: BatchFindByTreeIdsDto}> = (props) => {
          const {data} = props ?? {};

          return  questionControllerFindByTreeIdsBatch(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type QuestionControllerFindByTreeIdsBatchMutationResult = NonNullable<Awaited<ReturnType<typeof questionControllerFindByTreeIdsBatch>>>
    export type QuestionControllerFindByTreeIdsBatchMutationBody = BatchFindByTreeIdsDto
    export type QuestionControllerFindByTreeIdsBatchMutationError = ErrorType<unknown>

    /**
 * @summary Get questions for multiple tree IDs in a single request
 */
export const useQuestionControllerFindByTreeIdsBatch = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof questionControllerFindByTreeIdsBatch>>, TError,{data: BatchFindByTreeIdsDto}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationResult<
        Awaited<ReturnType<typeof questionControllerFindByTreeIdsBatch>>,
        TError,
        {data: BatchFindByTreeIdsDto},
        TContext
      > => {

      const mutationOptions = getQuestionControllerFindByTreeIdsBatchMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Returns questions belonging to a specific question tree (step), ordered by entryQuestionKeys. Includes translated label and description.
 * @summary Get questions by question tree ID
 */
export const questionControllerFindByTreeId = (
    treeId: number,
    params?: QuestionControllerFindByTreeIdParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<QuestionResponseDto[]>(
      {url: `/questions/tree/${treeId}`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getQuestionControllerFindByTreeIdQueryKey = (treeId: number,
    params?: QuestionControllerFindByTreeIdParams,) => {
    return [`/questions/tree/${treeId}`, ...(params ? [params]: [])] as const;
    }

    
export const getQuestionControllerFindByTreeIdInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof questionControllerFindByTreeId>>>, TError = ErrorType<void>>(treeId: number,
    params?: QuestionControllerFindByTreeIdParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof questionControllerFindByTreeId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getQuestionControllerFindByTreeIdQueryKey(treeId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof questionControllerFindByTreeId>>> = ({ signal }) => questionControllerFindByTreeId(treeId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(treeId), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof questionControllerFindByTreeId>>, TError, TData> & { queryKey: QueryKey }
}

export type QuestionControllerFindByTreeIdInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof questionControllerFindByTreeId>>>
export type QuestionControllerFindByTreeIdInfiniteQueryError = ErrorType<void>

/**
 * @summary Get questions by question tree ID
 */
export const useQuestionControllerFindByTreeIdInfinite = <TData = InfiniteData<Awaited<ReturnType<typeof questionControllerFindByTreeId>>>, TError = ErrorType<void>>(
 treeId: number,
    params?: QuestionControllerFindByTreeIdParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof questionControllerFindByTreeId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getQuestionControllerFindByTreeIdInfiniteQueryOptions(treeId,params,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getQuestionControllerFindByTreeIdQueryOptions = <TData = Awaited<ReturnType<typeof questionControllerFindByTreeId>>, TError = ErrorType<void>>(treeId: number,
    params?: QuestionControllerFindByTreeIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof questionControllerFindByTreeId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getQuestionControllerFindByTreeIdQueryKey(treeId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof questionControllerFindByTreeId>>> = ({ signal }) => questionControllerFindByTreeId(treeId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(treeId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof questionControllerFindByTreeId>>, TError, TData> & { queryKey: QueryKey }
}

export type QuestionControllerFindByTreeIdQueryResult = NonNullable<Awaited<ReturnType<typeof questionControllerFindByTreeId>>>
export type QuestionControllerFindByTreeIdQueryError = ErrorType<void>

/**
 * @summary Get questions by question tree ID
 */
export const useQuestionControllerFindByTreeId = <TData = Awaited<ReturnType<typeof questionControllerFindByTreeId>>, TError = ErrorType<void>>(
 treeId: number,
    params?: QuestionControllerFindByTreeIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof questionControllerFindByTreeId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getQuestionControllerFindByTreeIdQueryOptions(treeId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Creates a new question and links it to a survey. Optionally adds it to a QuestionTree (step) at a specific position.
 * @summary Create a new question
 */
export const questionControllerCreate = (
    createQuestionDto: CreateQuestionDto,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<CreateQuestionResponseDto>(
      {url: `/questions`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createQuestionDto
    },
      options);
    }
  


export const getQuestionControllerCreateMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof questionControllerCreate>>, TError,{data: CreateQuestionDto}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof questionControllerCreate>>, TError,{data: CreateQuestionDto}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof questionControllerCreate>>, {data: CreateQuestionDto}> = (props) => {
          const {data} = props ?? {};

          return  questionControllerCreate(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type QuestionControllerCreateMutationResult = NonNullable<Awaited<ReturnType<typeof questionControllerCreate>>>
    export type QuestionControllerCreateMutationBody = CreateQuestionDto
    export type QuestionControllerCreateMutationError = ErrorType<void>

    /**
 * @summary Create a new question
 */
export const useQuestionControllerCreate = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof questionControllerCreate>>, TError,{data: CreateQuestionDto}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationResult<
        Awaited<ReturnType<typeof questionControllerCreate>>,
        TError,
        {data: CreateQuestionDto},
        TContext
      > => {

      const mutationOptions = getQuestionControllerCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Returns all questions linked to the survey (raw fields).
 * @summary Get all questions by survey
 */
export const questionControllerFindBySurvey = (
    params: QuestionControllerFindBySurveyParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<QuestionDetailResponseDto[]>(
      {url: `/questions`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getQuestionControllerFindBySurveyQueryKey = (params: QuestionControllerFindBySurveyParams,) => {
    return [`/questions`, ...(params ? [params]: [])] as const;
    }

    
export const getQuestionControllerFindBySurveyInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof questionControllerFindBySurvey>>>, TError = ErrorType<unknown>>(params: QuestionControllerFindBySurveyParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof questionControllerFindBySurvey>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getQuestionControllerFindBySurveyQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof questionControllerFindBySurvey>>> = ({ signal }) => questionControllerFindBySurvey(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof questionControllerFindBySurvey>>, TError, TData> & { queryKey: QueryKey }
}

export type QuestionControllerFindBySurveyInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof questionControllerFindBySurvey>>>
export type QuestionControllerFindBySurveyInfiniteQueryError = ErrorType<unknown>

/**
 * @summary Get all questions by survey
 */
export const useQuestionControllerFindBySurveyInfinite = <TData = InfiniteData<Awaited<ReturnType<typeof questionControllerFindBySurvey>>>, TError = ErrorType<unknown>>(
 params: QuestionControllerFindBySurveyParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof questionControllerFindBySurvey>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getQuestionControllerFindBySurveyInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getQuestionControllerFindBySurveyQueryOptions = <TData = Awaited<ReturnType<typeof questionControllerFindBySurvey>>, TError = ErrorType<unknown>>(params: QuestionControllerFindBySurveyParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof questionControllerFindBySurvey>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getQuestionControllerFindBySurveyQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof questionControllerFindBySurvey>>> = ({ signal }) => questionControllerFindBySurvey(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof questionControllerFindBySurvey>>, TError, TData> & { queryKey: QueryKey }
}

export type QuestionControllerFindBySurveyQueryResult = NonNullable<Awaited<ReturnType<typeof questionControllerFindBySurvey>>>
export type QuestionControllerFindBySurveyQueryError = ErrorType<unknown>

/**
 * @summary Get all questions by survey
 */
export const useQuestionControllerFindBySurvey = <TData = Awaited<ReturnType<typeof questionControllerFindBySurvey>>, TError = ErrorType<unknown>>(
 params: QuestionControllerFindBySurveyParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof questionControllerFindBySurvey>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getQuestionControllerFindBySurveyQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Copies question definitions and English translations from one survey to another.
 * @summary Copy questions to another survey
 */
export const questionControllerCopyQuestions = (
    copyQuestionsDto: CopyQuestionsDto,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<CopyQuestionsResponseDto>(
      {url: `/questions/copy`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: copyQuestionsDto
    },
      options);
    }
  


export const getQuestionControllerCopyQuestionsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof questionControllerCopyQuestions>>, TError,{data: CopyQuestionsDto}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof questionControllerCopyQuestions>>, TError,{data: CopyQuestionsDto}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof questionControllerCopyQuestions>>, {data: CopyQuestionsDto}> = (props) => {
          const {data} = props ?? {};

          return  questionControllerCopyQuestions(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type QuestionControllerCopyQuestionsMutationResult = NonNullable<Awaited<ReturnType<typeof questionControllerCopyQuestions>>>
    export type QuestionControllerCopyQuestionsMutationBody = CopyQuestionsDto
    export type QuestionControllerCopyQuestionsMutationError = ErrorType<unknown>

    /**
 * @summary Copy questions to another survey
 */
export const useQuestionControllerCopyQuestions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof questionControllerCopyQuestions>>, TError,{data: CopyQuestionsDto}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationResult<
        Awaited<ReturnType<typeof questionControllerCopyQuestions>>,
        TError,
        {data: CopyQuestionsDto},
        TContext
      > => {

      const mutationOptions = getQuestionControllerCopyQuestionsMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Returns a single question with all fields for editing purposes.
 * @summary Get a question by ID
 */
export const questionControllerFindById = (
    id: number,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<QuestionDetailResponseDto>(
      {url: `/questions/${id}`, method: 'GET', signal
    },
      options);
    }
  

export const getQuestionControllerFindByIdQueryKey = (id: number,) => {
    return [`/questions/${id}`] as const;
    }

    
export const getQuestionControllerFindByIdInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof questionControllerFindById>>>, TError = ErrorType<void>>(id: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof questionControllerFindById>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getQuestionControllerFindByIdQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof questionControllerFindById>>> = ({ signal }) => questionControllerFindById(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof questionControllerFindById>>, TError, TData> & { queryKey: QueryKey }
}

export type QuestionControllerFindByIdInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof questionControllerFindById>>>
export type QuestionControllerFindByIdInfiniteQueryError = ErrorType<void>

/**
 * @summary Get a question by ID
 */
export const useQuestionControllerFindByIdInfinite = <TData = InfiniteData<Awaited<ReturnType<typeof questionControllerFindById>>>, TError = ErrorType<void>>(
 id: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof questionControllerFindById>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getQuestionControllerFindByIdInfiniteQueryOptions(id,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getQuestionControllerFindByIdQueryOptions = <TData = Awaited<ReturnType<typeof questionControllerFindById>>, TError = ErrorType<void>>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof questionControllerFindById>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getQuestionControllerFindByIdQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof questionControllerFindById>>> = ({ signal }) => questionControllerFindById(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof questionControllerFindById>>, TError, TData> & { queryKey: QueryKey }
}

export type QuestionControllerFindByIdQueryResult = NonNullable<Awaited<ReturnType<typeof questionControllerFindById>>>
export type QuestionControllerFindByIdQueryError = ErrorType<void>

/**
 * @summary Get a question by ID
 */
export const useQuestionControllerFindById = <TData = Awaited<ReturnType<typeof questionControllerFindById>>, TError = ErrorType<void>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof questionControllerFindById>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getQuestionControllerFindByIdQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Updates a question with the provided fields.
 * @summary Update a question
 */
export const questionControllerUpdate = (
    id: number,
    updateQuestionDto: UpdateQuestionDto,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<UpdateQuestionResponseDto>(
      {url: `/questions/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateQuestionDto
    },
      options);
    }
  


export const getQuestionControllerUpdateMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof questionControllerUpdate>>, TError,{id: number;data: UpdateQuestionDto}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof questionControllerUpdate>>, TError,{id: number;data: UpdateQuestionDto}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof questionControllerUpdate>>, {id: number;data: UpdateQuestionDto}> = (props) => {
          const {id,data} = props ?? {};

          return  questionControllerUpdate(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type QuestionControllerUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof questionControllerUpdate>>>
    export type QuestionControllerUpdateMutationBody = UpdateQuestionDto
    export type QuestionControllerUpdateMutationError = ErrorType<void>

    /**
 * @summary Update a question
 */
export const useQuestionControllerUpdate = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof questionControllerUpdate>>, TError,{id: number;data: UpdateQuestionDto}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationResult<
        Awaited<ReturnType<typeof questionControllerUpdate>>,
        TError,
        {id: number;data: UpdateQuestionDto},
        TContext
      > => {

      const mutationOptions = getQuestionControllerUpdateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    